import * as Api from "@api";
import * as C from "@components";

const ConsistentVaporizationCardContentBaseKey = "consistent-vaporization" as const;
const imageDirectory = `/images/products/@global/cards/`;

export const ConsistentVaporizationCardContentKeys = [
    `${ConsistentVaporizationCardContentBaseKey}.headline`,
    `${ConsistentVaporizationCardContentBaseKey}.body`
] as const;

interface ConsistentVaporizationCardProps
{
    pageContent: Api.Content<typeof ConsistentVaporizationCardContentKeys[number]>;
}

export const ConsistentVaporizationCard = ({ pageContent }: ConsistentVaporizationCardProps): React.FunctionComponentElement<ConsistentVaporizationCardProps> =>
    <C.ImageCard {...C.getImageCardStdProps({
        keyBase: ConsistentVaporizationCardContentBaseKey,
        width: C.Width.W40P,
        pageContent,
        imagePosition: C.CardImagePosition.Top,
        imageAlignment: C.HorizontalAlignment.Left,
        imageWidth: 414,
        imageHeight: 458,
        imageDirectory,
        headingMaxWidth: C.Width.W288,
        bodyMaxWidth: C.Width.W288,
        indentAfter: 22,
        indentBefore: 60,
        mobileImageProps: {
            mobileWidth: 768,
            mobileHeight: 620, 
        }
    })} />
